import styled from 'styled-components';
import { GridContainer } from '../GridContainer';
export const SubGrid = styled(GridContainer) `
  align-items: self-start;
  grid-gap: var(--layout-spoon) var(--layout-soybean);
  grid-template-columns: 160px auto;

  & > div {
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;

    & > button {
      overflow: hidden;
    }
  }
`;
